module.exports = __webpack_public_path__ + "img/lemon-left-5.1a8ed5b8.png";